// @flow

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';

const bold = css({
    fontWeight: 600,
    fontSize: '1.2em',
});

@observer
export default class Title extends Component {
    props: {
        boldText: string,
        normalText?: string,
    };

    render() {
        const { boldText, normalText } = this.props;

        return (
            <span>
                <span { ...bold }>
                    {boldText}
                </span>
                <span>
                    {normalText}
                </span>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Title/index.js